import { createAction, props } from '@ngrx/store';

import * as models from '../../domain/models';

export const load = createAction('[Sales.AdditionalFeatures] Load');
export const loadSuccess = createAction(
  '[Sales.AdditionalFeatures] Load Success',
  props<{ payload: Array<models.AdditionalFeature> }>()
);
export const loadFail = createAction('[Sales.AdditionalFeatures] Load Fail');

export const setInitial = createAction('[Sales.AdditionalFeatures] Set Initial');
